import {
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import CustomStore from 'devextreme/data/custom_store';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import {
  DxiColumnComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-grid-articoli-giacenze-compact',
  templateUrl: './grid-articoli-giacenze-compact.component.html',
  styleUrls: ['./grid-articoli-giacenze-compact.component.scss'],
  imports: [
    DxDataGridComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoTextsComponent,
    DxiColumnComponent,
    DxoExportComponent,
    DxoColumnChooserComponent,
    DxoEditingComponent,
    DxoLookupComponent,
    DxTemplateDirective,
  ],
  standalone: true,
})
export class GridArticoliGiacenzeCompactComponent
  extends GestArticoliBaseComponent
  implements OnChanges
{
  private navService = inject(NavigatorService);
  private tipiArticoliS = inject(TipiArticoliService);
  @Input() listArticoli;
  listTipiArticoli: any;

  dataSource: any;
  columnResizingMode = 'widget';

  constructor() {
    super();
    this.loadLookup();
  }

  ngOnChanges(changes: SimpleChanges) {
    const listChanged =
      changes['listArticoli'] &&
      changes['listArticoli'].currentValue !==
        changes['listArticoli'].previousValue;

    if (listChanged) {
      this.loadArticoli();
    }
  }

  loadLookup() {
    //Tipi Articoli
    this.tipiArticoliS.getListTipiArticoliTemp().subscribe({
      next: (res) => {
        this.listTipiArticoli = {
          store: {
            type: 'array',
            data: res.sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1)),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: () => {
        notificaMessaggio('Errore caricamento tipi articoli', 'warning');
      },
    });
  }

  loadArticoli() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.listArticoli;
      },
    });
  }

  sortByLookup(data) {
    const column = this as any;
    const value = column.calculateCellValue(data);
    const ret = column.lookup.calculateCellValue(value);
    return ret;
  }

  isSottoscorta(giacenza: number, scortaMinima: number): boolean {
    //if (!giacenza) return false;
    return giacenza > 0 && giacenza <= scortaMinima;
  }

  isEsaurito(giacenza: number): boolean {
    // if (!giacenza) return false;
    return giacenza <= 0;
  }

  goToDetail(e) {
    this.navService.goToArticoliDashboard(e);
  }
}
